/**
 * @generated SignedSource<<1af38e1302603880ffa81ff71a818ba5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UnitDSelectDialogTokenField_CourseTitle_courseQuery$variables = {
  id: string;
};
export type UnitDSelectDialogTokenField_CourseTitle_courseQuery$data = {
  readonly course: {
    readonly id: string;
    readonly title: string;
  };
};
export type UnitDSelectDialogTokenField_CourseTitle_courseQuery = {
  response: UnitDSelectDialogTokenField_CourseTitle_courseQuery$data;
  variables: UnitDSelectDialogTokenField_CourseTitle_courseQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Course",
    "kind": "LinkedField",
    "name": "course",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnitDSelectDialogTokenField_CourseTitle_courseQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnitDSelectDialogTokenField_CourseTitle_courseQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f7e14e38015bdbcc7e3a96e78518142f",
    "id": null,
    "metadata": {},
    "name": "UnitDSelectDialogTokenField_CourseTitle_courseQuery",
    "operationKind": "query",
    "text": "query UnitDSelectDialogTokenField_CourseTitle_courseQuery(\n  $id: ID!\n) {\n  course(id: $id) {\n    id\n    title\n  }\n}\n"
  }
};
})();

(node as any).hash = "c3d194d660a0c22b325dab6477560f10";

export default node;
